import React from 'react'
import { Image } from "@/components/Cloud/Cloud.model"
import { ComputeCatalogItem, DiskCatalogItem, ServerCatalog } from "../utils/types/Contract.grapqhl.types"
import { CurrentProfile, QuerysResponse } from "../utils/types/Contract.types"
import { PipesDisabledConfigAvailable, PipesDisabledConfigType } from "../utils/types/Contract.config.types"
import { MinMax, Pipes, PipesGeneric, ProductToCheckout, TooltipType } from "../utils/types/UiCloudMaterial.service.types"
import { UHCTooltipHardware } from "@/components/Cloud/Molecules/Slider/TooltipHardware/TooltipHardware"
import { PipesDisabledConfig } from "../utils/config/Contract.config"
import { UHCLockImageProps } from '@/components/Cloud/Molecules/Image/LockImage/LockImage'
import { UHCTooltipImagem } from '@/components/Cloud/Molecules/Slider/TooltipImage/TooltipImage'

export const cantDowngradeDiskMessage = 'Não é possível fazer downgrade de disco!'
export const cantDowngradeComputeBecauseOfDiskMessage = 'Opção indisponível. O tamanho de disco atual deste servidor é maior do que o máximo suportado para esta opção.'

export const setSlideMinOrIncluded = (
    serverCatalog: ServerCatalog,
    hardwareSelectedIndex: CurrentProfile,
    previousComputeIndex: number,
    currentImage?: Image) => {

    const slidesValidation = [PipesDisabledConfig.band, PipesDisabledConfig.disk]

    slidesValidation.forEach(val => {
        const minAvaliableIndex = serverCatalog[val.serverCatalogProp].sizes.findIndex(
            sc_val => sc_val === serverCatalog.computes[hardwareSelectedIndex.compute[0]][val.available].min)
        const minIncludedIndex = serverCatalog[val.serverCatalogProp].sizes.findIndex(sc_val => sc_val === serverCatalog.computes[hardwareSelectedIndex.compute[0]]["included"][val.currentProfile])
        const minImageIndex = (val.currentProfile === 'disk') ? serverCatalog[val.serverCatalogProp].sizes.findIndex(
            val_2 => val_2 === currentImage?.minRequirements[val.currentProfile]) : minIncludedIndex;

        const currentValue = getSizeValueByIndex(serverCatalog[val.serverCatalogProp].sizes, hardwareSelectedIndex[val.currentProfile][0])
        const maxAvailableValue = getComputeAvailableMaxValue(val.available, serverCatalog.computes, hardwareSelectedIndex.compute[0])
        const minIncludedValue = serverCatalog.computes[hardwareSelectedIndex.compute[0]].included[val.currentProfile]
        const minAvailableValue = getComputeAvailableMinValue(val.available, serverCatalog.computes, hardwareSelectedIndex.compute[0])
        const minPreviousValue = serverCatalog.computes[previousComputeIndex].included[val.currentProfile]
        const minImageValue = currentImage.minRequirements[val.currentProfile];

        let minValue = (minIncludedValue > minAvailableValue) ? minIncludedValue : minAvailableValue
        minValue = (minImageValue > minValue) ? minImageValue : minValue

        let minIndex = (minIncludedIndex > minAvaliableIndex) ? minIncludedIndex : minAvaliableIndex
        minIndex = (minImageIndex > minIndex) ? minImageIndex : minIndex


        if (minValue > currentValue || minPreviousValue === currentValue) {
            hardwareSelectedIndex[val.currentProfile][1](minIndex);
        } else if (maxAvailableValue < currentValue) {
            const maxIndex = serverCatalog[val.serverCatalogProp].sizes.findIndex(sc_val => sc_val === serverCatalog.computes[hardwareSelectedIndex.compute[0]][val.available].max)
            hardwareSelectedIndex[val.currentProfile][1](maxIndex);
        }

    })
}

export const callBackOnclickLineImageLocked = (
    querysResponse: QuerysResponse,
    hardwareSelectedIndex: CurrentProfile,
    setImageSelected: React.Dispatch<React.SetStateAction<Image | undefined>>,
    setImageSelectedIndex: React.Dispatch<React.SetStateAction<number>>,
) => {
    
    return (image: Image) => {
        updateCurrentImageFindIndex(querysResponse.images, image, setImageSelected, setImageSelectedIndex)
        updateGenericHardware(hardwareSelectedIndex.compute[1], getComputeIndexByMinReqImage(querysResponse.serverCatalog.computes, image))
        updateGenericHardware(hardwareSelectedIndex.disk[1], getDiskIndexByMinReqImage(querysResponse.serverCatalog.disks, image))
    }
}

export const redirToCheckout = (querysResponse: QuerysResponse, pipesConverted: Pipes, currentIndexProfile: CurrentProfile, currentIndexImage: [number, React.Dispatch<React.SetStateAction<number>>],) => {
    const productToCheckout = getProductToCheckout(querysResponse, pipesConverted, currentIndexProfile, currentIndexImage);
    const encoded = encodeToOrderbox(productToCheckout);
    return window.location.assign(`https://checkout.cloud.painel.uol.com.br/checkout?productType=cloud&orderbox=${encoded}`);
}

export const getSizeValueByIndex = (sizes: number[], index: number) => {
    return sizes[index]
}

export const getComputeByIndex = (computes: ComputeCatalogItem[], index: number) => {
    return computes[index]
}

export const getHardwareMinMax = (serverCatalogResponse: ServerCatalog, prop: PipesDisabledConfigType, hardwareSelectedIndex: CurrentProfile,) => {
    const currentServer = serverCatalogResponse.computes[hardwareSelectedIndex.compute[0]][prop.available]

    const minHardware = serverCatalogResponse[prop.serverCatalogProp].sizes.findIndex(val => val === currentServer.min);
    const maxHardware = serverCatalogResponse[prop.serverCatalogProp].sizes.findIndex(val => val === currentServer.max);

    return {
        minHardware,
        maxHardware
    }
}

const getComputeAvailableMinValue = (prop: PipesDisabledConfigAvailable['available'], computes: ComputeCatalogItem[], computeIndex: number) => {
    return computes[computeIndex][prop].min
}

const getComputeAvailableMaxValue = (prop: PipesDisabledConfigAvailable['available'], computes: ComputeCatalogItem[], computeIndex: number) => {
    return computes[computeIndex][prop].max
}

const getHardwareCurrentByIndex = (computes: ComputeCatalogItem[], index: number): ComputeCatalogItem['hardware'] => {
    return computes[index].hardware
}

function getImageIndexByImage(images: Image[], image: Image) {
    return images.findIndex(val => val.id === image.id)
}
function getComputeIndexByMinReqImage(computes: ComputeCatalogItem[], image: Image) {
    return computes.findIndex(val => val.hardware.memory === image.minRequirements?.memory && val.hardware.vcpu === image.minRequirements?.vcpu)
}
function getDiskIndexByMinReqImage(disks: DiskCatalogItem, image: Image) {
    return disks.sizes.findIndex(val => val === image.minRequirements?.disk)
}

export const getMinImage = (
    prop: PipesDisabledConfigType,
    serverCatalogResponse: ServerCatalog,

    currentImage: Image
) => {
    const content = {
        'bandwidth': getMinIndexMemoryImage(serverCatalogResponse, currentImage),
        'disk': serverCatalogResponse.disks.sizes.findIndex(val => val === currentImage.minRequirements?.disk)
    }

    return content[prop.currentProfile]
}

export function getMinIndexMemoryImage(serverCatalogResponse: ServerCatalog, currentImage: Image) {
    return serverCatalogResponse.computes.findIndex(val => val.hardware.memory == currentImage.minRequirements?.memory  && val.hardware.vcpu == currentImage.minRequirements?.vcpu)
}

////////////////////////////////////////////////
//calculo de preços
////////////////////////////////////////////////
const getMinPrice = (
    prop: PipesDisabledConfigType,
    serverCatalogResponse: ServerCatalog,
    minValue: number) => {
    return serverCatalogResponse[prop.serverCatalogProp].price * minValue
}


export const calcGenericPipePricec = (
    prop: PipesDisabledConfigType,
    size: number,
    serverCatalogResponse: ServerCatalog,
    minValue: number
): number => {

    const price = serverCatalogResponse[prop.serverCatalogProp].price;
    const priceIncludes = getMinPrice(prop, serverCatalogResponse, minValue);

    if (minValue === size) return 0

    const result = (size * price) - priceIncludes
    return result
}


////////////////////////////////////////////////
//#FIM - calculo de preços
////////////////////////////////////////////////

////////////////////////////////////////////////
//formatação de dados
////////////////////////////////////////////////

const convertDiskToSting = (size: number) => {
    return `${size} GB`;
}

const convertBandwidthToSting = (size: number) => {
    return `${size} Mb/s`;
}

export const convertMemoryToString = (size: number) => {
    if (size < 1024) {
        return `${size} MB`;
    } else {
        return `${size / 1024} GB`
    }
}

const convertStringMemoryToNumber = (size: string) => {
    if (size.endsWith('MB')) {
        return parseInt(size) * 1;
    } else if (size.endsWith('GB')) {
        return parseInt(size) * 1024;
    }
}


const encodeToOrderbox = function (productToCheckout: ProductToCheckout) {
    return btoa(JSON.stringify(productToCheckout))
}



const getTextMemoryAndVcpu = (hardware: ComputeCatalogItem['hardware']) => {
    return `${convertMemoryToString(hardware.memory)} - ${hardware.vcpu}vCPU`
}

export const getTooltip = (
    prop: PipesDisabledConfigType,
    minMax: MinMax,
    pipesVal: PipesGeneric,
    computesVal: ComputeCatalogItem,
    hardwareSelectedIndex: CurrentProfile,
    computesIndex: number,
    pipesIndex: number,
    serverCatalogResponse: ServerCatalog,
    currentImage: Image,
) => {
    const isDisk = prop.currentProfile == 'disk'
    const isBandwidth = prop.currentProfile == 'bandwidth'

    const getTooltipContent = (tooptipType: TooltipType, customText?: string) => {
        if (customText) return <UHCTooltipHardware customText={customText} />

        if (tooptipType === 'image') return <UHCTooltipImagem image={currentImage} />

        const hardWareTooltipCallback = () => {
            hardwareSelectedIndex.compute[1](computesIndex)
            hardwareSelectedIndex[prop.currentProfile][1](pipesIndex)
        }

        return <UHCTooltipHardware onlyAvailable={getTextMemoryAndVcpu(computesVal.hardware)} functionCallback={hardWareTooltipCallback} />
    }

    if (isDisk && (pipesIndex < minMax.minAvaiable && minMax.minAvaiable <= minMax.min)) {
        pipesVal.tooltip = getTooltipContent('hardware', cantDowngradeDiskMessage)
        return pipesVal
    }

    const minImage = getMinImage(prop, serverCatalogResponse, currentImage);
    let tooptipType: TooltipType = 'hardware';

    if ((pipesIndex < minMax.min) || (pipesIndex < minImage) || pipesIndex > minMax.max) {
        if (isBandwidth) {
            const minRequirementByImage = getMinIndexMemoryImage(serverCatalogResponse, currentImage)
            if (pipesIndex < minRequirementByImage) tooptipType = 'image'
        }

        if (isDisk) {
            const minRequirementDisk = serverCatalogResponse.disks.sizes.findIndex(val => val === currentImage.minRequirements?.disk)
            if (pipesIndex < minRequirementDisk) tooptipType = 'image'
        }

        pipesVal.tooltip = getTooltipContent(tooptipType)
    }

    return pipesVal
}

export const convertDiskPipeWithTooltip = (
    prop: PipesDisabledConfigType,
    diskPipes: PipesGeneric[],
    diskMinMaxIndex: MinMax,
    hardwareSelectedIndex: CurrentProfile,
    serverCatalogResponse: ServerCatalog,
    currentImage: Image): PipesGeneric[] => {

    return diskPipes.map((diskPipe, index) => {

        if (index < diskMinMaxIndex.min || index > diskMinMaxIndex.max) {
            let isTooltip = false

            serverCatalogResponse.computes.map((computesVal, computesIndex) => {
                const diskValueByIndex = getSizeValueByIndex(serverCatalogResponse.disks.sizes, index)
                if (index < diskMinMaxIndex.min) {

                    computesVal.diskAvailable
                    if (computesVal.included.disk <= diskValueByIndex) {

                        diskPipe = { ...getTooltip(prop, diskMinMaxIndex, diskPipe, computesVal, hardwareSelectedIndex, computesIndex, index, serverCatalogResponse, currentImage) }
                    }
                } else {
                    if (index > diskMinMaxIndex.max) {
                        if (computesVal.diskAvailable.max >= diskValueByIndex) {
                            if (!isTooltip) {
                                diskPipe = { ...getTooltip(prop, diskMinMaxIndex, diskPipe, computesVal, hardwareSelectedIndex, computesIndex, index, serverCatalogResponse, currentImage) }
                                isTooltip = true
                            }
                        }
                    }
                }
                return
            })

        }
        return diskPipe
    })
}

const convertBandwidthPipeWithTooltip = (
    prop: PipesDisabledConfigType,
    bandiwdthPipes: PipesGeneric[],
    bandiwdthMinMaxIndex: MinMax,
    hardwareSelectedIndex: CurrentProfile,
    serverCatalogResponse: ServerCatalog,
    currentImage: Image): PipesGeneric[] => {

    return bandiwdthPipes.map((bandiwdthPipe, index) => {


        if (index < bandiwdthMinMaxIndex.min || index > bandiwdthMinMaxIndex.max) {
            let isTooltip = false

            serverCatalogResponse.computes.map((computesVal, computesIndex) => {
                const bandiwdthValueByIndex = getSizeValueByIndex(serverCatalogResponse[prop.serverCatalogProp].sizes, index)
                if (index < bandiwdthMinMaxIndex.min) {
                    if (computesVal[prop.available].min <= bandiwdthValueByIndex) {
                        bandiwdthPipe = { ...getTooltip(prop, bandiwdthMinMaxIndex, bandiwdthPipe, computesVal, hardwareSelectedIndex, computesIndex, index, serverCatalogResponse, currentImage) }
                    }
                } else {
                    if (index > bandiwdthMinMaxIndex.max) {
                        if (
                            computesVal[prop.available].max >= bandiwdthValueByIndex) {
                            if (!isTooltip) {
                                bandiwdthPipe = { ...getTooltip(prop, bandiwdthMinMaxIndex, bandiwdthPipe, computesVal, hardwareSelectedIndex, computesIndex, index, serverCatalogResponse, currentImage) }
                                isTooltip = true
                            }
                        }
                    }
                }
                return
            })

        }
        return bandiwdthPipe
    })
}


export const convertDatasToPipes = (
    serverCatalogResponse: ServerCatalog,
    currentImage: Image,
    currentIndexProfile: CurrentProfile,
): Pipes => {

    let pipesComputes: PipesGeneric[] = [];
    let pipesDisks: PipesGeneric[] = [];
    let pipesBandwidths: PipesGeneric[] = [];

    serverCatalogResponse.computes.forEach(
        val => {
            const value = convertMemoryToString(val.hardware.memory)
            const price = val.prices.discount?.price ?? val.prices.price

            pipesComputes = [...pipesComputes, {
                vcpu: val.hardware.vcpu,
                value,
                price
            }]
        }
    )

    serverCatalogResponse.disks.sizes.forEach(
        val => {
            const includedDisk = serverCatalogResponse.computes[currentIndexProfile.compute[0]].included.disk;
            const value = convertDiskToSting(val);
            const price = calcGenericPipePricec(
                PipesDisabledConfig.disk,
                val,
                serverCatalogResponse,
                includedDisk
            )
            pipesDisks = [...pipesDisks, { value, price, }]
        }
    )

    serverCatalogResponse.bandwidths.sizes.forEach(
        (val) => {
            const includedBand = serverCatalogResponse.computes[currentIndexProfile.compute[0]].included.bandwidth;
            const value = convertBandwidthToSting(val)
            const price = calcGenericPipePricec(PipesDisabledConfig.band,
                val,
                serverCatalogResponse,
                includedBand
            )
            pipesBandwidths = [...pipesBandwidths, { value, price }]
        }
    )

    const bandwidthMinMax = getPipeDisabled(PipesDisabledConfig.band, currentIndexProfile, serverCatalogResponse, currentImage)
    const diskMinMax = getPipeDisabled(PipesDisabledConfig.disk, currentIndexProfile, serverCatalogResponse, currentImage)

    const pipesBandConverted = convertBandwidthPipeWithTooltip(PipesDisabledConfig.band, pipesBandwidths, bandwidthMinMax, currentIndexProfile, serverCatalogResponse, currentImage)
    const pipesDiskConverted = convertDiskPipeWithTooltip(PipesDisabledConfig.disk, pipesDisks, diskMinMax, currentIndexProfile, serverCatalogResponse, currentImage)
    const pipesComputeConverted = convertComputePipeWithTooltip(pipesComputes, diskMinMax, currentIndexProfile, serverCatalogResponse, currentImage)

    return {
        computes: pipesComputeConverted,
        bandwidths: pipesBandConverted,
        disks: pipesDiskConverted
    };
}

export function convertComputePipeWithTooltip(pipesComputes: PipesGeneric[],
    diskMinMax: MinMax,
    hardwareSelectedIndex: CurrentProfile,
    serverCatalogResponse: ServerCatalog,
    currentImage: Image): PipesGeneric[] {


    const result = pipesComputes.map(pipeCompute => {
        let tooltip = <UHCTooltipImagem image={currentImage} />

        const isChangePlan = diskMinMax.minAvaiable != 0

        if (!isChangePlan) return {
            ...pipeCompute,
            tooltip
        }

        const serverCatalogComputeObject = serverCatalogResponse.computes.find(compute => compute.hardware.memory == convertStringMemoryToNumber(pipeCompute.value) && compute.hardware.vcpu == pipeCompute.vcpu)
        const disksSizes = serverCatalogResponse.disks.sizes

        const selectedDiskIndex = hardwareSelectedIndex.disk[0]
        const maxDiskIndexAtCompute = disksSizes.findIndex((diskSize) => diskSize == serverCatalogComputeObject.diskAvailable.max)

        if (maxDiskIndexAtCompute < selectedDiskIndex) {
            tooltip = <UHCTooltipHardware customText={cantDowngradeComputeBecauseOfDiskMessage} />
        }

        return {
            ...pipeCompute,
            tooltip
        }
    })

    return result
}

export const getComputePipeDisabled = (
    serverCatalogResponse: ServerCatalog,
    currentImage: Image,
    diskMinMax?: MinMax): MinMax => {

    const minIndexSelectMemoryImage = getMinIndexMemoryImage(serverCatalogResponse, currentImage);

    let min = minIndexSelectMemoryImage
    const shouldConsiderDisk = diskMinMax.minAvaiable != 0;
    if (shouldConsiderDisk) {
        const diskSizeByIndex = serverCatalogResponse.disks.sizes[diskMinMax.min]
        const minComputeByDisk = serverCatalogResponse.computes.findIndex(compute => compute.diskAvailable.max >= diskSizeByIndex)

        min = minIndexSelectMemoryImage > minComputeByDisk ? minIndexSelectMemoryImage : minComputeByDisk
    }

    return {
        minAvaiable: minIndexSelectMemoryImage,
        min,
        max: 15
    }
}

export const getPipeDisabled = (
    prop: PipesDisabledConfigType,
    hardwareSelectedIndex: CurrentProfile,
    serverCatalogResponse: ServerCatalog,
    currentImage: Image
): MinMax => {
    const avaiableObject = serverCatalogResponse.computes[hardwareSelectedIndex.compute[0]][prop.available]

    const minAvaiableBySelectedIndex = avaiableObject.min
    const maxAvaiableBySelectedIndex = avaiableObject.max

    let minAvaiable = 0

    const shouldConsiderMinAvaiable = prop.serverCatalogProp == 'bandwidths' || serverCatalogResponse.computes.some(compute => compute.diskAvailable.min != compute.included.disk)

    if (shouldConsiderMinAvaiable) {
        minAvaiable = serverCatalogResponse[prop.serverCatalogProp].sizes.findIndex(val => val === minAvaiableBySelectedIndex)
    }
    const minImage = getMinImage(prop, serverCatalogResponse, currentImage);

    let min = 0


    if (prop.currentProfile === 'disk') {
        const minIncluded = serverCatalogResponse.disks.sizes.findIndex(sc_val => sc_val === serverCatalogResponse.computes[hardwareSelectedIndex.compute[0]].included.disk)
        min = (minAvaiable > minImage) ? minAvaiable : minImage
        min = (minIncluded > min) ? minIncluded : min
    } else {
        min = (minAvaiable > minImage) ? minAvaiable : minImage
    }

    return {
        minAvaiable,
        min,
        max: serverCatalogResponse[prop.serverCatalogProp].sizes.findIndex(val => val === maxAvaiableBySelectedIndex),
    }
}

function getProductToCheckout(
    querysResponse: QuerysResponse,
    pipesConverted: Pipes,
    currentProfile: CurrentProfile,
    currentImage: [number, React.Dispatch<React.SetStateAction<number>>]
): ProductToCheckout {
    return {
        "bandwidth": querysResponse.serverCatalog.bandwidths.sizes[currentProfile.bandwidth[0]],
        "product": `Server_${pipesConverted.computes[currentProfile.compute[0]].value.replace(/\s/g, '')}_${pipesConverted.computes[currentProfile.compute[0]].vcpu}vCPU_G3_Mensal_CloudMeter`,
        "disk": querysResponse.serverCatalog.disks.sizes[currentProfile.disk[0]],
        "image": querysResponse.images[currentImage[0]].id,
        "group": querysResponse.group
    }
}

////////////////////////////////////////////////
//#FIM - formatação de dados
////////////////////////////////////////////////


////////////////////////////////////////////////
//PROPS PARA COMPONENTES DA LIB DE COMPONENTES
////////////////////////////////////////////////

export function getHardwareToLockImage(
    serverCatalog: QuerysResponse['serverCatalog'],
    currentProfile: CurrentProfile
): UHCLockImageProps['hardware'] {
    const hardware = getHardwareCurrentByIndex(serverCatalog.computes, currentProfile.compute[0])
    const disk = getSizeValueByIndex(serverCatalog.disks.sizes, currentProfile.disk[0])
    return {
        vcpu: hardware.vcpu,
        memory: hardware.memory,
        disk: disk
    }
}

////////////////////////////////////////////////
//#FIM - PROPS PARA COMPONENTES DA LIB DE COMPONENTES
////////////////////////////////////////////////


/////////////////////////////////
///update hooks
/////////////////////////////////

const updateGenericHardware = (setCompute: React.Dispatch<React.SetStateAction<number>>, index: number) => {
    setCompute(index)
}

const updateCurrentImageFindIndex = (
    images: Image[],
    image: Image,
    setImageSelected: React.Dispatch<React.SetStateAction<Image | undefined>>,
    setImageSelectedIndex: React.Dispatch<React.SetStateAction<number>>
) => {
    updateCurrentImage(images, getImageIndexByImage(images, image), setImageSelected, setImageSelectedIndex)
}

export const updateCurrentImage = (
    images: Image[],
    index: number,
    setImageSelected: React.Dispatch<React.SetStateAction<Image | undefined>>,
    setImageSelectedIndex: React.Dispatch<React.SetStateAction<number>>

) => {
    setImageSelected(images[index])
    setImageSelectedIndex(index)

}